import { Tag } from "lucide-react"
import { testIds } from "@/lib/test-ids"

interface TagsViewProps {
  onTagContextMenu?: (tag: string, event: React.MouseEvent) => void
}

export function TagsView({ onTagContextMenu }: TagsViewProps) {
  const tags = [
    { name: "ggia", count: 12, color: "blue" },
    { name: "frontend", count: 8, color: "green" },
    { name: "feature", count: 15, color: "purple" },
    { name: "security", count: 3, color: "red" },
    { name: "audit", count: 2, color: "orange" },
    { name: "hop-studios", count: 25, color: "blue" },
    { name: "scrum", count: 5, color: "green" },
    { name: "meeting", count: 8, color: "purple" },
    { name: "backend", count: 6, color: "gray" },
    { name: "api", count: 4, color: "blue" },
  ]

  const getTagColor = (color: string) => {
    switch (color) {
      case "blue": return "bg-blue-100 text-blue-800 hover:bg-blue-200"
      case "green": return "bg-green-100 text-green-800 hover:bg-green-200"
      case "purple": return "bg-purple-100 text-purple-800 hover:bg-purple-200"
      case "red": return "bg-red-100 text-red-800 hover:bg-red-200"
      case "orange": return "bg-orange-100 text-orange-800 hover:bg-orange-200"
      case "gray": return "bg-gray-100 text-gray-800 hover:bg-gray-200"
      default: return "bg-sidebar-accent text-sidebar-foreground hover:bg-sidebar-accent/80"
    }
  }

  return (
    <div className="flex-1 overflow-y-auto min-h-0" data-testid={testIds.tagsView.container}>
      <div className="p-3">
        <div className="mb-3">
          <h3 className="text-xs font-semibold text-sidebar-foreground/70 px-2 mb-2">ALL TAGS</h3>
          <div className="space-y-1" data-testid={testIds.tagsView.list}>
            {tags.map((tag) => (
              <button
                key={tag.name}
                className="w-full flex items-center justify-between px-3 py-2 rounded-md hover:bg-sidebar-accent text-left text-sm text-sidebar-foreground transition-colors group"
                onContextMenu={(e) => {
                  e.preventDefault()
                  onTagContextMenu?.(tag.name, e)
                }}
              >
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getTagColor(tag.color)}`}>
                    #{tag.name}
                  </span>
                </div>
                <span className="text-xs text-sidebar-foreground/50">{tag.count}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-sidebar-border pt-3">
          <h3 className="text-xs font-semibold text-sidebar-foreground/70 px-2 mb-2">RECENT TAGS</h3>
          <div className="space-y-1">
            {tags.slice(0, 5).map((tag) => (
              <button
                key={`recent-${tag.name}`}
                className="w-full flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-sidebar-accent text-left text-sm text-sidebar-foreground transition-colors"
              >
                <Tag className="h-3 w-3 text-sidebar-foreground/60" />
                <span>#{tag.name}</span>
                <span className="ml-auto text-xs text-sidebar-foreground/50">{tag.count}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

